import { useLocation } from "react-router-dom";

export const useMobileWithLogo = () => {
  const { pathname } = useLocation();
  const withLogo = pathname.includes("register") || pathname.includes("login");
  return withLogo ? true : false;
};
